<sn-drawer toastContainer>
  <ng-container *ngIf="isQuickSearch(data) && data.label__in && !pursuitMode && this.allowAi">
    <sn-drawer-header [title]="'map.drawing.searchResults.searchDetectionsResults' | t">
      <p>{{ 'map.drawing.searchResults.searchResults' | t }}: {{count}}</p>
    </sn-drawer-header>
  </ng-container>
  <ng-container *ngIf="isQuickSearch(data) && data.label__in && pursuitMode">
    <p id="sentry-results-count">{{ 'map.drawing.searchResults.searchResults' | t }}: {{count}}</p>
  </ng-container>
  <ng-container *ngIf="isQuickSearch(data) && data.events__label__in">
    <sn-drawer-header [title]="'map.drawing.searchResults.searchEventsResults' | t">
      <p>{{ 'map.drawing.searchResults.searchResults' | t }}: {{count}}</p>
    </sn-drawer-header>
  </ng-container>
  <ng-container *ngIf="isQuickSearch(data) && !data.label__in && !data.events__label__in">
    <sn-drawer-header [title]="'map.drawing.searchResults.searchResults' | t">
      <p>{{ 'map.drawing.searchResults.searchResults' | t }}: {{count}}</p>
    </sn-drawer-header>
  </ng-container>
    <sn-drawer-content (scroll)="onScroll($event)" [ngStyle]="{'max-height': pursuitMode ? '30vh' : null}" id="sentry-results-drawer">
      <ng-container *ngIf="(aiResults.length > 0) || isLoading; else empty">
        <mat-card class="results-card" *ngFor="let item of aiResults; trackBy: trackSentrySearch">
          <fs-sentry-search-pagination
            [pursuitMode]="pursuitMode"
            [item]="item"
            [creationDate]="item.timestamp"
            [id]="item.cameraId"
            [queryParams]="data"
          ></fs-sentry-search-pagination>
        </mat-card>
      </ng-container>
      <ng-template #empty>
        <div class="empty-results">{{ 'common.noResultsFound' | t }}</div>
      </ng-template>

    <div class="loading" *ngIf="isLoading">
      <mat-progress-spinner
        color="accent"
        diameter="32"
        mode="indeterminate"
      ></mat-progress-spinner>
    </div>
  </sn-drawer-content>
</sn-drawer>
